/**
 * Mobile pinned scroll-story sections (page order).
 * Nav to any later hash implies earlier story sections were passed forward.
 */
export const MOBILE_STORY_SECTION_HASHES = [
  "#live",
  "#ai-tutor",
  "#journey",
];

const MOBILE_PAGE_HASHES_AFTER_STORIES = [
  "#testimonials",
  "#programs",
  "#founders",
];

/** Anchor hashes that are strictly below a given scroll-story section. */
export function mobileStoryHashesBelowStory(sectionHash) {
  const storyIdx = MOBILE_STORY_SECTION_HASHES.indexOf(sectionHash);
  const below = new Set(MOBILE_PAGE_HASHES_AFTER_STORIES);
  if (storyIdx < 0) return below;
  for (let i = storyIdx + 1; i < MOBILE_STORY_SECTION_HASHES.length; i += 1) {
    below.add(MOBILE_STORY_SECTION_HASHES[i]);
  }
  return below;
}
